export default __webpack_public_path__ + "static/media/discuss.5076923f.svg";